//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';

export default {
  name: 'index',
  props: ['params'],
  created: async function () {
    let { acId } = this.params;
    let acIds = acId.split('-');
    let activityId = acIds[1];
    if(!G.member || !G.member.token){
      G.member = JSON.parse(localStorage.getItem(acIds[0]) || '{}');
    }
    if(!G.member || !G.member.token){
      this.jumpMeituAuth(acId);
    }
    this.mamberInfo = G.member;
    await this.activityInfo(acId);
  },
  data() {
    return {
      activityDto: {
        activityImg: '',
        goodsId: 0,
        goodsInfoId: 0,
        homeLink: '',
        activityLink: '',
        personalLink: '',
      },
      buyNum: 1,
      mamberInfo: {}
    };
  },
  computed: {},
  filters: {},
  components: {},
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/meituActivity/page.vue